import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/questions.action'
import * as fromQuestionActions from '../../../actions/questions.action'
import { editOpenEndedQuestion } from 'api/administration/questions/Edit'
import { getQuestionList } from 'api/administration/questions/List'
import { IOpenEndedModel } from 'models/questionOpenEnded.model'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function getList(instanceId: number) {
  return await getQuestionList(instanceId)
}

async function handleEditOpenEnded(data: IOpenEndedModel, questionId: number) {
  return await editOpenEndedQuestion(data, questionId)
}

function* editOpenEndedEffectSaga(action: any) {
  try {
    const {
      data: { data, instanceId, questionId },
    } = action
    yield call(handleEditOpenEnded, data, questionId)
    const questionList = yield call(getList, instanceId)
    yield put(fromQuestionActions.Actions.questionsListSuccess(questionList))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editOpenEndedWatcherSaga() {
  yield takeLatest(fromActions.QUESTION_OPENENDED_EDIT, editOpenEndedEffectSaga)
}
